import React from "react";
import CfcDraggableRegistration from "./CfcDraggableRegistration";

class CfcCycleRegistrations extends React.Component {
  render() {
    var cfcRegistrations = this.props.cfcRegistrations;
    return (
      <div className="mosaic">
        {cfcRegistrations.map((cfcRegistration, index) => (
          <CfcDraggableRegistration key={cfcRegistration.id} cfcRegistration={cfcRegistration} />
        ))}
      </div>
    );
  }
}

export default CfcCycleRegistrations;
